import React from "react";
import InvoicesPrint from "../AFReadyDisigen/InvoicesPrint";
export default function InvTempalte(props) {
    return (
        <div>
            <InvoicesPrint  typeInv={4} />
        </div>
    );
}